import { Outlet } from "react-router-dom";
import Layout from "../../components/layouts/Layout";
import AccountingLayout from "../../components/layouts/AccountingLayout";

const Accounting = () => {
  return (
    <Layout pageTitle={`Finance & Accounting`}>
        <AccountingLayout>
            <Outlet />
        </AccountingLayout>
    </Layout>
  )
}

export default Accounting